/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

// eslint-disable-next-line no-restricted-imports
import Bluebird from 'bluebird';

import { Analytics } from '@trello/atlassian-analytics';
import { isMemberLoggedIn } from '@trello/authentication';
import { getNonPublicIfAvailable } from '@trello/business-logic/member';
import { ApiError } from '@trello/error-handling';
import { getInvitationCookieData } from '@trello/invitation-links';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import type { PIIString } from '@trello/privacy';
import { navigate } from '@trello/router/navigate';
import { getOrganizationUrl } from '@trello/urls';

import { errorPage } from 'app/scripts/controller/errorPage';
import { getBoardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { ModelLoader } from 'app/scripts/db/model-loader';
import { ModelCache } from 'app/scripts/db/ModelCache';
import Payloads from 'app/scripts/network/payloads';
import { InviteRestrictValues } from 'app/scripts/views/organization/Constants';
import { TrelloBoard } from 'app/src/components/Board';
import { legacyBoardModelsSharedState } from 'app/src/components/Board/legacyBoardModelsSharedState';
import { InvitationLinkPage } from 'app/src/components/InvitationLinkPage';
import { getSpinner } from 'app/src/getSpinner';
import type { Board } from '../models/Board';
import type { Organization } from '../models/Organization';
import { controllerEvents } from './controllerEvents';

const _handleInvitation = function ({
  id,
  loadModel,
  targetUrl,
  transferUrl,
  viewType,
  apiUrl,
  idModelFromInvite,
  nameFromInvite,
  emailRestrictionsFromInvite,
  inviteRestrictionUrlFromEnterprise,
  managedRestrictionsFromInvite,
  modelName,
  analyticsContainers,
  getMemberships,
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
any) {
  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const { ApiPromise } = require('app/scripts/network/ApiPromise');
  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const {
    renderTopLevelComponent,
  } = require('app/scripts/controller/renderTopLevelComponent');
  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const {
    RequestAdminInviteView,
  } = require('app/scripts/views/invitation-link/RequestAdminInviteView');
  // Dependency required at call site to avoid import cycles, do not lift to top of module
  const { JoinOnConfirm } = require('app/scripts/lib/join-on-confirm');

  const redirectIfMember = () => {
    return ModelLoader.await('headerData')
      .then(() => {
        if (!isMemberLoggedIn()) {
          throw ApiError.Unauthorized();
        }
        return loadModel();
      })
      .then((boardOrOrganization: Board | Organization) => {
        let url;
        if (modelName === 'Board' && boardOrOrganization.typeName === 'Board') {
          legacyBoardModelsSharedState.setValue({
            board: { model: boardOrOrganization, loading: false, error: null },
          });
        }

        if ((url = targetUrl()) != null) {
          return navigate(url, { trigger: true, replace: true });
        } else {
          throw ApiError.Unauthorized();
        }
      });
  };

  const taskName =
    modelName === 'Board'
      ? 'edit-board/members/accept-invite'
      : 'edit-organization/members/accept-invite';
  const source =
    modelName === 'Board'
      ? 'acceptBoardInvitationScreen'
      : 'acceptTeamInvitationScreen';

  const traceId = Analytics.startTask({
    taskName,
    source,
  });

  // Immediately start fetching the invitation data
  const getInvite =
    apiUrl != null
      ? ApiPromise({
          url: apiUrl,
          type: 'get',
          traceId,
        })
          .then((result: unknown) => {
            taskName &&
              source &&
              traceId &&
              Analytics.taskSucceeded({
                taskName,
                source,
                traceId,
              });
            return result;
          })
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          .catch(ApiError.NotFound, (error: any) => {
            taskName &&
              source &&
              traceId &&
              Analytics.taskAborted({
                taskName,
                source,
                traceId,
                error,
              });

            throw error;
          })
      : Bluebird.reject(ApiError.NotFound());

  return Bluebird.using(getSpinner(), () => {
    $('#content').html('<div class="spinner loading"></div>');
    return JoinOnConfirm.autoJoin()
      .then(() =>
        // Check to see if we're already a member of the board, in which case
        // we can go straight there.  Otherwise, go through the invitation
        // acceptance process
        redirectIfMember(),
      )
      .catch(
        ApiError.NotFound,
        ApiError.Unauthorized,
        ApiError.Unconfirmed,
        () => {
          controllerEvents.trigger('clearPreviousView');

          const me = Auth.me();
          if (me != null) {
            // @ts-expect-error TS(2769): No overload matches this call.
            controllerEvents.trigger('setViewType', me);
          }

          return Bluebird.props({
            invite: getInvite,
            member: isMemberLoggedIn()
              ? ModelLoader.loadMemberLogins(Auth.myId())
              : undefined,
          }).then(({ invite }) => {
            let invitationLinkView;

            if (!invite.inviteeCanAccept) {
              // @ts-expect-error
              invitationLinkView = this.topLevelView(
                RequestAdminInviteView,
                me,
                { memberInviter: invite.memberInviter },
              );
              return $('#content').html(invitationLinkView.render().el);
            }
            if (
              isMemberLoggedIn() &&
              !Auth.confirmed() &&
              modelName === 'Board'
            ) {
              renderTopLevelComponent(<TrelloBoard />);
            } else {
              renderTopLevelComponent(
                <InvitationLinkPage
                  modelName={modelName}
                  inviterName={
                    getNonPublicIfAvailable(
                      invite.memberInviter,
                      'fullName',
                    ) as PIIString | undefined
                  }
                  inviterId={invite.memberInviter.id}
                  modelNameText={nameFromInvite(invite)}
                  emailRestrictions={emailRestrictionsFromInvite(invite)}
                  allowManagedMembers={managedRestrictionsFromInvite(invite)}
                  inviteIdEnterprise={
                    invite.organization != null
                      ? invite.organization.idEnterprise
                      : undefined
                  }
                  transferUrl={
                    typeof transferUrl === 'function'
                      ? transferUrl()
                      : undefined
                  }
                  willJoinOnConfirm={JoinOnConfirm.inQueue(apiUrl)}
                  /* eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow */
                  fxJoin={(traceId: any) => {
                    return ApiPromise({
                      method: 'post',
                      url: apiUrl,
                      traceId,
                    }).then(redirectIfMember);
                  }}
                  fxQueueJoin={() => {
                    return JoinOnConfirm.add(apiUrl);
                  }}
                  analyticsContainers={analyticsContainers(invite)}
                  memberships={getMemberships(invite)}
                  inviteRestrictionUrlFromEnterprise={inviteRestrictionUrlFromEnterprise(
                    invite,
                  )}
                />,
              );
            }
          });
        },
      );
  });
};

// The loadModel method gets called before the user has accepted the
// invitation in order to check whether or not they're already a member of
// the board. Unfortunately, this can lead to a stale cache as the endpoint
// to accept the invite doesn't trigger any cache invalidation, so we have
// to do it ourselves to prevent the users from getting stuck here without
// getting redirected after accepting the invite.
const clearModelFromCache = (
  modelType: 'Board' | 'Workspace',
  idOrShortLink: string,
) => {
  let cachedModel: Board | Organization | undefined;

  if (modelType === 'Board') {
    cachedModel = ModelCache.get(modelType, idOrShortLink);
  }

  // For some reason TypeScript complains about the modelType union / "Board"
  // not being compatible with the ModelCache.get() overloads if we do, for example:
  // ModelCache.get(modelType === 'Workspace' ? "Organization" : "Board", idOrShortLink);
  if (modelType === 'Workspace') {
    cachedModel = ModelCache.get('Organization', idOrShortLink);
  }

  if (cachedModel) {
    ModelCache.remove(cachedModel);
  }
};

export const InviteAcceptPage = {
  boardInvitationPage() {
    const {
      type,
      orgOrBoardId: shortLinkOrBoardId,
      secret,
    } = getInvitationCookieData();

    const apiUrl =
      type === 'board' && shortLinkOrBoardId && secret
        ? `/1/board/${shortLinkOrBoardId}/invitationSecret/${secret}`
        : null;

    _handleInvitation
      .call(this, {
        loadModel() {
          if (shortLinkOrBoardId) {
            clearModelFromCache('Board', shortLinkOrBoardId);

            // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
            return ModelLoader.loadBoardData(
              shortLinkOrBoardId,
              Payloads.currentBoardMinimal,
            );
          } else {
            throw ApiError.BadRequest('invalid board shortLink or id');
          }
        },
        targetUrl: () => {
          const board = ModelCache.get('Board', shortLinkOrBoardId);

          if (
            // TL;DR: If they've been successfully added, do the redirect
            board?.isMember(Auth.me()) ||
            board?.isObserver(Auth.me())
          ) {
            return getBoardUrl(board);
          }

          return null;
        },
        viewType: 'board-invitation-link',
        apiUrl,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        idModelFromInvite(invite: any) {
          return invite.board.id;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        nameFromInvite(invite: any) {
          return invite.board.name;
        },
        emailRestrictionsFromInvite() {
          return [];
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inviteRestrictionUrlFromEnterprise(invite: any) {
          return null;
        },
        managedRestrictionsFromInvite() {
          return false;
        },
        modelName: 'Board',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        analyticsContainers(invitee: any) {
          return {
            board: { id: invitee.board.id },
          };
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        getMemberships(invite: any) {
          return invite.board.memberships || [];
        },
      })
      .catch(ApiError, (e) => {
        // The invitation link isn't valid anymore, show a message to that effect
        return errorPage({
          errorType: 'invalidBoardInvite',
        });
      });
  },

  teamInvitationPage() {
    const {
      type,
      orgOrBoardId: workspaceNameOrId,
      secret,
    } = getInvitationCookieData();

    const apiUrl =
      type === 'organization' && workspaceNameOrId && secret
        ? `/1/organization/${workspaceNameOrId}/invitationSecret/${secret}`
        : null;

    _handleInvitation
      .call(this, {
        loadModel() {
          if (workspaceNameOrId) {
            clearModelFromCache('Workspace', workspaceNameOrId);

            return ModelLoader.loadOrganizationData(workspaceNameOrId);
          } else {
            throw ApiError.BadRequest('invalid org name or id');
          }
        },
        targetUrl: () => {
          const workspace = ModelCache.findOne(
            'Organization',
            (o: Organization) =>
              o.get('name') === workspaceNameOrId || o.id === workspaceNameOrId,
          );

          if (workspace?.isMember(Auth.me())) {
            return getOrganizationUrl(workspace.get('name'));
          }

          return null;
        },
        transferUrl() {
          const workspace = ModelCache.findOne(
            'Organization',
            (o: Organization) =>
              o.get('name') === workspaceNameOrId || o.id === workspaceNameOrId,
          );

          if (!workspace) {
            return '#';
          }

          return `/${workspace.get('name')}/transfer-account`;
        },
        viewType: 'org-invitation-link',
        apiUrl,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        idModelFromInvite(invite: any) {
          return invite.organization.id;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        nameFromInvite(invite: any) {
          return invite.organization.displayName;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        emailRestrictionsFromInvite(invite: any) {
          let left;
          return (left = (
            invite.organization.prefs != null
              ? invite.organization.prefs.orgInviteRestrict
              : undefined
          )?.filter(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (value: any) =>
              !Object.values(InviteRestrictValues).includes(value),
          )) != null
            ? left
            : [];
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        managedRestrictionsFromInvite(invite: any) {
          let left;
          return (left = (
            invite.organization.prefs != null
              ? invite.organization.prefs.orgInviteRestrict
              : undefined
          )
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ?.some((value: any) =>
              [
                InviteRestrictValues.MANAGED,
                InviteRestrictValues.MANAGED_OR_DOMAIN,
              ].includes(value),
            )) != null
            ? left
            : false;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        inviteRestrictionUrlFromEnterprise(invite: any) {
          return invite?.organization?.prefs?.newLicenseInviteRestrictUrl;
        },
        modelName: 'Team',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        analyticsContainers(invitee: any) {
          return { workspace: { id: invitee.organization.id } };
        },
        getMemberships() {
          return [];
        },
      })
      .catch(ApiError, (e) => {
        // The invitation link isn't valid anymore, show a message to that effect
        return errorPage({
          errorType: 'invalidWorkspaceInvite',
        });
      });
  },
};
